import type { FaireProductEntity } from "../../entity_types/product";

export const p_6e54mmyp2a: FaireProductEntity = {
  token: "p_6e54mmyp2a",
  type: "product",
  name: "Margarita / Mezcal Tasting Glasses - Clear",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/727eea522c246469a852fd7b5d5dab59f46875f58d4009f1e144a7d2370f6eed.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4e1ece6245bb12d8c50f2e90728559ce3adeacb0ae510b123ecd5984d1746df6.jpeg",
    "https://cdn.faire.com/fastly/6032598adcf222ff916c3ada7333615ba41417c2062d5cc8b0a478316083ca43.jpeg",
    "https://cdn.faire.com/fastly/2cc9dcf32845ebeff61d5035fa5dabad90aeb9f0a688d7fb0a5cc17ead1e1379.jpeg",
    "https://cdn.faire.com/fastly/2cce0024d67e222aed5156f00618d900fd39c3b32b6f52f569d5ef467728c1b4.jpeg",
    "https://cdn.faire.com/fastly/d72caaf7f7067b372b58e9bfcda4f17f407fe4e93a543edbd7bda3ca6d6da0ea.jpeg",
    "https://cdn.faire.com/fastly/dbae25c16c8d45633acf215b072650d73ed5cba9838780c84aa02ecf5754947e.jpeg",
    "https://cdn.faire.com/fastly/c3855024e311d82deb4403c6149ce055a3a5a019d744a37d8d11a8ff0688de4f.jpeg",
    "https://cdn.faire.com/fastly/1bcebd5ad5fcea3a0fec801f1b2d3ff6de23c4db09acd3b31bb006d16e232d99.jpeg",
  ],
  priceDollars: 10,
  description:
    "**Packaged in sets of 2 as shown; sold as 8 single glasses in a master (4 boxes of 2 glasses)**\n\nIntroducing our Handblown Mexican Glasses in Clear - the perfect match for simple, understated, and no-fuss drinks. Sustainably handcrafted by our talented glassblowing artisans in Jalisco, Mexico, each glass is meticulously shaped while molten hot, preserving its distinctive character. Available in sets of 4 for both short and highball sizes, because great drinks are meant to be enjoyed together. Elevate your drinking experience with these exquisite handblown glasses. Cheers to sustainability and craftsmanship!\n\nBe sure to check out our entire Clear Mexican Glassware Collection, including Highball Glasses, Short DOF Glasses, Shooter Glasses, and matching Pitcher! \n\nCare: Dishwasher safe - Susceptible to breakage with extreme temperature changes. \n\nCapacity:\n400ml / 14 oz \n\nDimensions:\nEach Glass - 3.25'' tall x 4.75'' diameter\n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:16.719Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
